import type { FeatureGroup } from '../../../../types';
import { DOMAINS_FEATURE_GROUP } from '../group';

export const DOMAINS_WEB_FEATURE_GROUP: FeatureGroup = {
  guid: 'd7e93a14-5c82-4f6b-a019-3b8e72f1ff00',
  name: 'domains:web',
  description: 'Web domain features — register, verify, and manage web domains',
  product: 'account',
  parentGuid: DOMAINS_FEATURE_GROUP.guid,
};
